import { createStructuredSelector } from 'reselect'

const initialState = {
  tableParams: {},
  isModalOpen: false,
  selectedDisruptions: [],
  selectedRow: [],
  auxiliarSelectedRow: null,
  hideActionBar: false
}

export const applicationDisruptionsDetailsReducer = (state = initialState, { payload, type } = {}) => {
  switch (type) {
    case setTableParams.type:
      return {
        ...state,
        tableParams: payload
      }
    case setModalIsOpen.type:
      return {
        ...state,
        isModalOpen: payload
      }
    case setSelectedDisruptions.type:
      return {
        ...state,
        selectedDisruptions: payload
      }
    case setSelectedRow.type:
      return {
        ...state,
        selectedRow: payload
      }
    case setHideActionBar.type:
      return {
        ...state,
        hideActionBar: payload
      }
    case setAuxiliarSelectedRow.type:
      return {
        ...state,
        auxiliarSelectedRow: payload
      }
    case resetTableSelection.type:
      return {
        ...state,
        isModalOpen: false,
        selectedRow: [],
        auxiliarSelectedRow: [],
        hideActionBar: true
      }
    default:
      return state
  }
}
applicationDisruptionsDetailsReducer.slice = 'application-disruptions-details'

export const setTableParams = (tableParams = {}) => ({ type: setTableParams.type, payload: tableParams })
setTableParams.type = 'application-disruptions-details/setTableParams'

export const setModalIsOpen = (isModalOpen = false) => ({ type: setModalIsOpen.type, payload: isModalOpen })
setModalIsOpen.type = 'application-disruptions-details/setModalIsOpen'

export const setSelectedDisruptions = (selectedDisruptions = []) => ({ type: setSelectedDisruptions.type, payload: selectedDisruptions })
setSelectedDisruptions.type = 'application-disruptions-details/setSelectedDisruptions'

export const setSelectedRow = (selectedRow = []) => ({ type: setSelectedRow.type, payload: selectedRow })
setSelectedRow.type = 'application-disruptions-details/setSelectedRow'

export const setAuxiliarSelectedRow = (auxiliarSelectedRow = []) => ({ type: setAuxiliarSelectedRow.type, payload: auxiliarSelectedRow })
setAuxiliarSelectedRow.type = 'application-disruptions-details/setAuxiliarSelectedRow'

export const setHideActionBar = (hideActionBar = false) => ({ type: setHideActionBar.type, payload: hideActionBar })
setHideActionBar.type = 'application-disruptions-details/setHideActionBar'

export const resetTableSelection = () => ({ type: resetTableSelection.type })
resetTableSelection.type = 'application-disruptions-details/resetTableSelection'

export const getTableParams = state => state[applicationDisruptionsDetailsReducer.slice].tableParams
export const getModalIsOpen = state => state[applicationDisruptionsDetailsReducer.slice].isModalOpen
export const getSelectedDisruptions = state => state[applicationDisruptionsDetailsReducer.slice].selectedDisruptions
export const getSelectedRow = state => state[applicationDisruptionsDetailsReducer.slice].selectedRow
export const getAuxiliarSelectedRow = state => state[applicationDisruptionsDetailsReducer.slice].auxiliarSelectedRow
export const getHideActionBar = state => state[applicationDisruptionsDetailsReducer.slice].hideActionBar

export const getDetailsDataTableSelectors = createStructuredSelector({
  tableParams: getTableParams,
  isModalOpen: getModalIsOpen,
  selectedDisruptions: getSelectedDisruptions,
  selectedRow: getSelectedRow,
  auxiliarSelectedRow: getAuxiliarSelectedRow,
  hideActionBar: getHideActionBar
})
